import { render, staticRenderFns } from "./system_notify.vue?vue&type=template&id=f488e782&scoped=true"
import script from "./system_notify.vue?vue&type=script&lang=ts"
export * from "./system_notify.vue?vue&type=script&lang=ts"
import style0 from "./system_notify.vue?vue&type=style&index=0&id=f488e782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f488e782",
  null
  
)

export default component.exports